import { memo, useCallback } from 'react';

import { CheckoutContributionConfirmationResponseType } from 'src/models/Checkout/Confirmation';
import { UiCleanInput } from 'src/components/UI/inputs/CleanInput';
import { useStateForm } from 'src/utils/stateForm';
import { useTHelper } from 'src/utils/i18n';
import { UiButton } from 'src/components/UI/Button';
import { dispatchAnyRequestStart } from 'src/store/anyRequest/helpers';
import { apiSaveContributionNote } from 'src/api/checkout';
import { useAnyRequest } from 'src/utils/hooks/useAnyRequest';
import { UiToast } from 'src/components/UI/toasts';
import { UiCard } from 'src/components/UI/Card';

type Props = {
  model: CheckoutContributionConfirmationResponseType['PublicNoticeSubsection'];
};

type FormValues = {
  note: Props['model']['Note'];
};

export const CheckoutConfirmationPublicNotice = memo<Props>(({ model }) => {
  const tHelper = useTHelper('checkout.confirmation.publicNotice');

  const formProps = useStateForm<FormValues>({
    defaultValues: {
      note: model.Note,
    },
  });

  const singular = model.ProjectTerminology.Singular?.toLowerCase() || '';

  const uniqueId = 'saveContributionNote';

  const saveContributionNote = useCallback(() => {
    dispatchAnyRequestStart({
      data: { Note: formProps.getValue('note'), ContributionGuid: model.ContributionGuid },
      apiFunction: apiSaveContributionNote,
      uniqueId,
    });
  }, [formProps, model.ContributionGuid]);

  useAnyRequest(uniqueId, {
    onSuccess: () => UiToast.success(tHelper('success', { singular })),
  });

  return (
    <>
      <h2 className="section-header">{tHelper('title')}</h2>
      <UiCard>
        <p className="text-center comment-printable">{tHelper('label', { singular })}</p>
        <UiCleanInput
          name="note"
          formProps={formProps}
          maxLength={2000}
          disabled={!model.CanSaveContributionNote}
          placeholder={tHelper('placeholder', { singular })}
          showAmount={false}
        />

        {model.CanSaveContributionNote && (
          <div className="row">
            <div className="buttons-container left-align">
              <UiButton tag="a" primary primaryNew className="btn btn-lg" onClick={saveContributionNote}>
                {tHelper('save')}
              </UiButton>
            </div>
          </div>
        )}
      </UiCard>
    </>
  );
});
